import React, { useEffect } from 'react';
import { useState } from 'react';

const SessionTimeoutCountdown: React.FC<{
  initialMinutes: number;
  onExpire: () => void;
}> = ({ initialMinutes = 5, onExpire }) => {
  const [seconds, setSeconds] = useState(initialMinutes * 60);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(interval);
          if (onExpire) onExpire();
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onExpire]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <span className="timeout-countdown">
      {minutes}:
      {remainingSeconds < 10
        ? `0${remainingSeconds}`
        : remainingSeconds}
    </span>
  );
};

export default SessionTimeoutCountdown;
